import axios from 'axios';
import config from '../config';

const baseUrl = config.LIMS_API_URLS;

export async function addLabContacts(values) {
    return await axios
        .post(baseUrl + '/labContact/create', values)
        .then((response) => {
            let userResponse = response.data;

            if (userResponse.isSucess === true) {
                return userResponse.response;
            } else {
                return userResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
export async function updateLabContact(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/labContact/update/' + id, values)
        .then((response) => {
            let labContactResponse = response.data;

            if (labContactResponse.isSucess === true) {
                return labContactResponse.response;
            } else {
                return labContactResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function deleteLabContact(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/labContact/delete/' + id)
        .then((response) => {
            let labContactResponse = response.data;
            if (labContactResponse.isSucess === true) {
                return labContactResponse.response;
            } else {
                return labContactResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
export async function getAllLabContact(values) {
    return await axios
        .post(baseUrl + '/labContact/allLabContact', values)
        .then((response) => {
            let labContactResponse = response.data;
            if (labContactResponse.isSucess === true) {
                return labContactResponse.response;
            } else {
                return labContactResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getLabContactHistory(values) {
    return await axios.post(baseUrl + '/labContact/history', values).then((response) => {
        let labContactResponse = response.data;
        if (labContactResponse.isSucess === true) {
            return labContactResponse.response;
        } else {
            return labContactResponse.response;
        }
    });
}

export async function getAllManagerData() {
    return await axios.post(baseUrl + '/labContact/allLabContact').then((response) => {
        let managerResponse = response.data;
        if (managerResponse.isSucess === true) {
            return managerResponse.response;
        } else {
            return managerResponse.response;
        }
    });
}

export async function addLabDepartments(values) {
    return await axios
        .post(baseUrl + '/labDepartment/create', values)
        .then((response) => {
            let LabDepartmentsResponse = response.data;

            if (LabDepartmentsResponse.isSucess === true) {
                return LabDepartmentsResponse.response;
            } else {
                return LabDepartmentsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function updateLabDepartments(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/labDepartment/update/' + id, values)
        .then((response) => {
            let labDepartmentsResponse = response.data;
            if (labDepartmentsResponse.isSucess === true) {
                return labDepartmentsResponse.response;
            } else {
                return labDepartmentsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
export async function getAllDepartmentsPagenationData(values) {
    return await axios
        .post(baseUrl + '/labDepartment/allLabDepartment', values)
        .then((response) => {
            let departmentsResponse = response.data;
            if (departmentsResponse.isSucess === true) {
                return departmentsResponse.response;
            } else {
                return departmentsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAllDepartmentsData(values) {
    return await axios
        .post(baseUrl + '/labDepartment/allLabDepartment', values)
        .then((response) => {
            let departmentsResponse = response.data;
            if (departmentsResponse.isSucess === true) {
                return departmentsResponse.response.data;
            } else {
                return departmentsResponse.response.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function deleteDepartments(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/labDepartment/delete/' + id)
        .then((response) => {
            let labDepartmentsResponse = response.data;
            if (labDepartmentsResponse.isSucess === true) {
                return labDepartmentsResponse.response;
            } else {
                return labDepartmentsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getLabDepartmentHistory(values) {
    return await axios.post(baseUrl + '/labDepartment/history', values).then((response) => {
        let labDepartmentsResponse = response.data;
        if (labDepartmentsResponse.isSucess === true) {
            return labDepartmentsResponse.response;
        } else {
            return labDepartmentsResponse.response;
        }
    });
}

export async function addAnalysisCategory(values) {
    return await axios.post(baseUrl + '/analysisCategory/create', values).then((response) => {
        let analysisCategoryResponse = response.data;
        if (analysisCategoryResponse.isSucess === true) {
            return analysisCategoryResponse.response;
        } else {
            return analysisCategoryResponse.response;
        }
    });
}

export async function addAnalysisService(values) {
    return await axios
        .post(baseUrl + '/analysisService/create', values)
        .then((response) => {
            let analysisServiceResponse = response.data;
            if (analysisServiceResponse.isSucess === true) {
                return analysisServiceResponse.response;
            } else {
                return analysisServiceResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addClients(values) {
    return await axios.post(baseUrl + '/clients/create', values).then((response) => {
        let clientsResponse = response.data;
        if (clientsResponse.isSucess === true) {
            return clientsResponse.response;
        } else {
            return clientsResponse.response;
        }
    });
}

// export async function addOrder(values) {
//     let reqData = {
//         enquiryId: values._id,
//         clientId: values.clientId,
//         clientName: values.clientName,
//         expiryDate: values.expiryDate,
//         contactPerson: values.contactPerson,
//         orderStatus: values.orderStatus,
//         orderList: JSON.stringify(values.orderList),
//         userId: values.userId,
//         seq: values.seq,
//         files: values.file,
//     };
//     console.log(reqData,"reqData 238")
//     return await axios.post(baseUrl + '/order/create', reqData,
//         {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//             maxBodyLength: Infinity,
//             maxContentLength: Infinity,
//         }).then((response) => {
//         let orderResponse = response.data;
//         if (orderResponse.isSucess === true) {
//             return orderResponse.response;
//         } else {
//             return orderResponse;
//         }
//     });
// }

export async function addOrder(values) {

    const formData = new FormData();

    formData.append('enquiryId', values._id || '');
    formData.append('clientId', values.clientId || '');
    formData.append('isFssai', values.isFssai || '');
    formData.append('clientName', values.clientName || '');
    formData.append('expiryDate', values.expiryDate || '');
    formData.append('contactPerson', values.contactPerson || '');
    formData.append('orderStatus', values.orderStatus || '');
    formData.append(
        'orderList',
        JSON.stringify(values.orderList || [])
    );
    formData.append('userId', values.userId || '');
    formData.append('seq', values.seq || '');

    if (values.file && values.file.length > 0) {
        values.file.forEach((file) => {
            formData.append('files', file);
        });
    }

    return await axios.post(
        baseUrl + '/order/create',
        formData,
        {
            maxBodyLength: Infinity,
            maxContentLength: Infinity,
        }
    ).then((response) => {

        let orderResponse = response.data;

        if (orderResponse.isSucess === true) {
            return orderResponse.response;
        } else {
            return orderResponse;
        }
    });
}

export async function addEnquiryOrder(values) {
    values.testImage = values.file;
    const formData = new FormData();
    for (let i = 0; i < values.file.length; i++) {
        formData.append('files', values.file[i]);
    }
    formData.append('files', values.file[0]);
    formData.append('clientName', values.clientName);
    formData.append('contactPerson', values.contactPerson)
    formData.append('orderStatus', values.orderStatus);
    formData.append('orderList', JSON.stringify(values.orderList));
    formData.append('history', JSON.stringify(values.history ? values.history : []));

    return await axios.post(baseUrl + '/enquiry/createOrder', values).then((response) => {
        let orderResponse = response.data;
        if (orderResponse.isSucess === true) {
            return orderResponse.response;
        } else {
            return orderResponse;
        }
    });
}

export async function updateOrder(values) {
    let id = values._id;
    const formData = new FormData();

    formData.append('clientName', values.clientName);
    formData.append('orderStatus', values.orderStatus);
    formData.append('orderList', JSON.stringify(values.orderList ? values.orderList : []));
    formData.append('history', JSON.stringify(values.history));

    return await axios.post(baseUrl + '/order/update/' + id, values).then((response) => {
        let orderResponse = response.data;
        if (orderResponse.isSucess === true) {
            return orderResponse.response;
        } else {
            return orderResponse;
        }
    });
}

export async function updateOrderFile(values) {
    let id = values._id;
    // values.testImage = values.file;
    const formData = new FormData();
    for (let i = 0; i < values.file.length; i++) {
        formData.append('files', values.file[i]);
    }
    formData.append('clientId', values.clientId);
    formData.append('orderStatus', values.orderStatus);
    formData.append('orderList', JSON.stringify(values.orderList ? values.orderList : []));
    formData.append('history', JSON.stringify(values.history ? values.history : []));

    return await axios.post(baseUrl + '/order/updateFile/' + id, formData).then((response) => {
        let orderResponse = response.data;
        if (orderResponse.isSucess === true) {
            return orderResponse.response;
        } else {
            return orderResponse;
        }
    });
}
export async function deleteOrder(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/order/delete/' + id).then((response) => {
        let orderResponse = response.data;
        if (orderResponse.isSucess === true) {
            return orderResponse.response;
        } else {
            return orderResponse;
        }
    });
}

export async function deleteOrderFile(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/order/deleteFile/' + id, values).then((response) => {
        let orderResponse = response.data;
        if (orderResponse.isSucess === true) {
            return orderResponse.response;
        } else {
            return orderResponse;
        }
    });
}

export async function getAllOrder(values) {
    return await axios
        .post(baseUrl + '/order/allOrder', values)
        .then((response) => {
            let orderResponse = response.data;
            if (orderResponse.isSucess === true) {
                return orderResponse.response;
            } else {
                return orderResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAllOrderActiveAndInactive(values) {
    return await axios
        .post(baseUrl + '/order/allOrder/activeAndinactive', values)
        .then((response) => {
            let orderResponse = response.data;
            if (orderResponse.isSucess === true) {
                return orderResponse.response;
            } else {
                return orderResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getOrderAPI(id) {
    return await axios
        .post(baseUrl + '/enquiry/order/' + id)
        .then((response) => {
            let orderResponse = response.data;
            if (orderResponse.isSucess === true) {
                return orderResponse.response;
            } else {
                return orderResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getOrderHistory(values) {
    return await axios.post(baseUrl + '/order/history', values).then((response) => {
        let orderResponse = response.data;
        if (orderResponse.isSucess === true) {
            return orderResponse.response;
        } else {
            return orderResponse.response;
        }
    });
}

export async function addEnquiry(values) {
    const formData = new FormData();

    for (let i = 0; i < values.file.length; i++) {
        formData.append('files', values.file[i]);
    }

    formData.append('clientId', values.clientId);
    formData.append('contactPerson', values.contactPerson);
    formData.append('isFssai', values.isFssai);
    formData.append('orderStatus', values.orderStatus);
    formData.append('enquiryList', JSON.stringify(values.enquiryList));
    formData.append('userId', values.userId);

    // ✅ Correct way to see FormData content
    return await axios.post(baseUrl + '/enquiry/create', formData)
        .then((response) => {
            let enquiryResponse = response.data;
            if (enquiryResponse.isSucess === true) {
                return enquiryResponse.response;
            } else {
                return enquiryResponse;
            }
        });
}

export async function updateEnquiry(values) {
    let id = values._id;
    // values.testImage = values.file;
    const formData = new FormData();
    formData.append('clientId', values.clientId);
    formData.append('contactPerson', values.contactPerson);
    formData.append('isFssai', values.isFssai)
    formData.append('orderStatus', values.orderStatus);
    formData.append(
        'enquiryList',
        JSON.stringify(values.enquiryList || [])
    );
    formData.append('userId', values.userId);
    formData.append('history', JSON.stringify(values.history));
    return await axios.post(baseUrl + '/enquiry/update/' + id, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            maxBodyLength: Infinity,
            maxContentLength: Infinity,
        }).then((response) => {
            let enquiryResponse = response.data;
            if (enquiryResponse.isSucess === true) {
                return enquiryResponse.response;
            } else {
                return enquiryResponse;
            }
        });
}

// export async function updateEnquiry(values) {
//     let id = values._id;

//     const formData = new FormData();

//     formData.append('clientId', values.clientId || '');
//     formData.append('contactPerson', values.contactPerson || '');
//     formData.append('isFssai', values.isFssai || '');
//     formData.append('orderStatus', values.orderStatus || '');
//     formData.append(
//         'enquiryList',
//         JSON.stringify(values.enquiryList || [])
//     );
//     formData.append('userId', values.userId || '');
//     formData.append(
//         'history',
//         JSON.stringify(values.history || [])
//     );

//     console.log(values, "values 431");

//     return await axios.post(
//         baseUrl + '/enquiry/update/' + id,
//         formData,
//         {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//             maxBodyLength: Infinity,
//             maxContentLength: Infinity,
//         }
//     ).then((response) => {
//         let enquiryResponse = response.data;

//         if (enquiryResponse.isSucess === true) {
//             return enquiryResponse.response;
//         } else {
//             return enquiryResponse;
//         }
//     });
// }

export async function updateEnquiryFile(values) {
    let id = values._id;
    const formData = new FormData();
    for (let i = 0; i < values.file.length; i++) {
        formData.append('files', values.file[i]);
    }
    formData.append('clientId', values.clientId);
    formData.append('contactPerson', values.contactPerson);
    formData.append('orderStatus', values.orderStatus);
    formData.append('isFssai', values.isFssai)
    formData.append('enquiryList', JSON.stringify(values.enquiryList));
    formData.append('history', JSON.stringify(values.history ? values.history : []));

    return await axios.post(baseUrl + '/enquiry/updateFile/' + id, formData).then((response) => {
        let enquiryResponse = response.data;
        if (enquiryResponse.isSucess === true) {
            return enquiryResponse.response;
        } else {
            return enquiryResponse;
        }
    });
}
export async function deleteEnquiry(values) {
    let id = values._id;

    return await axios.post(baseUrl + '/enquiry/delete/' + id).then((response) => {
        let enquiryResponse = response.data;
        if (enquiryResponse.isSucess === true) {
            return enquiryResponse.response;
        } else {
            return enquiryResponse;
        }
    });
}
export async function deleteEnquiryFile(values) {
    let id = values._id;

    return await axios.post(baseUrl + '/enquiry/deleteFile/' + id, values).then((response) => {
        let enquiryResponse = response.data;
        if (enquiryResponse.isSucess === true) {
            return enquiryResponse.response;
        } else {
            return enquiryResponse;
        }
    });
}

export async function getAllEnquiry(values) {
    return await axios
        .post(baseUrl + '/enquiry/allEnquiry', values)
        .then((response) => {
            let enquiryResponse = response.data;
            if (enquiryResponse.isSucess === true) {
                return enquiryResponse.response;
            } else {
                return enquiryResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getEnquiryHistory(values) {
    return await axios.post(baseUrl + '/enquiry/history', values).then((response) => {
        let enquiryResponse = response.data;
        if (enquiryResponse.isSucess === true) {
            return enquiryResponse.response;
        } else {
            return enquiryResponse.response;
        }
    });
}

export async function compressImageFile(file, maxWidth = 1000, maxHeight = 1000, quality = 0.7) {
    if (typeof window === 'undefined' || !file || !(file instanceof Blob)) {
        return file;
    }

    const isImage = (file.type && file.type.startsWith('image/')) ||
        /\.(jpe?g|png|webp|bmp|gif|tiff?)$/i.test(file.name || '');

    if (!isImage) {
        return file;
    }

    // If file is already an image, is jpeg, and is under 300KB, it's already safe
    if (file.size <= 300 * 1024 && file.type === 'image/jpeg') {
        return file;
    }

    return new Promise((resolve) => {
        try {
            const reader = new FileReader();
            reader.onload = (event) => {
                const img = new Image();
                img.onload = async () => {
                    try {
                        let width = img.width;
                        let height = img.height;

                        if (width > maxWidth || height > maxHeight) {
                            if (width / height > maxWidth / maxHeight) {
                                height = Math.round((height * maxWidth) / width);
                                width = maxWidth;
                            } else {
                                width = Math.round((width * maxHeight) / height);
                                height = maxHeight;
                            }
                        }

                        const canvas = document.createElement('canvas');
                        canvas.width = width;
                        canvas.height = height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, width, height);

                        const toBlobAsync = (q) =>
                            new Promise((res) => {
                                canvas.toBlob(res, 'image/jpeg', q);
                            });

                        let blob = await toBlobAsync(quality);

                        // If still larger than 400KB, reduce quality and canvas size
                        if (blob && blob.size > 400 * 1024) {
                            blob = await toBlobAsync(0.5);
                        }
                        if (blob && blob.size > 400 * 1024) {
                            const scaledCanvas = document.createElement('canvas');
                            scaledCanvas.width = Math.round(width * 0.75);
                            scaledCanvas.height = Math.round(height * 0.75);
                            const sCtx = scaledCanvas.getContext('2d');
                            sCtx.drawImage(canvas, 0, 0, scaledCanvas.width, scaledCanvas.height);
                            blob = await new Promise((res) => scaledCanvas.toBlob(res, 'image/jpeg', 0.5));
                        }

                        if (!blob) {
                            return resolve(file);
                        }

                        const baseName = (file.name || 'sample_image.jpg').replace(/\.[^.]+$/, '');
                        const compressedFile = new File([blob], `${baseName}.jpg`, {
                            type: 'image/jpeg',
                            lastModified: Date.now(),
                        });
                        resolve(compressedFile);
                    } catch (err) {
                        resolve(file);
                    }
                };
                img.onerror = () => resolve(file);
                img.src = event.target.result;
            };
            reader.onerror = () => resolve(file);
            reader.readAsDataURL(file);
        } catch (e) {
            resolve(file);
        }
    });
}

export function sanitizeSamplePayload(values) {
    if (!values || typeof values !== 'object') return values;
    const cleaned = { ...values };

    // Strip heavy non-persisted UI states and read-only calculated properties
    delete cleaned.action_history;
    delete cleaned.serialNumber;
    delete cleaned.taxPercentage;
    delete cleaned.invoiceDescription;
    delete cleaned.totalSampleCost;
    delete cleaned.enquiryListLength;
    delete cleaned.noOfAnalysisService;
    delete cleaned.testedDataResult;
    delete cleaned.tableData;
    delete cleaned.dataEditDelete;
    delete cleaned.check;

    // ---- Prevent payload duplication (root cause of 413) ----
    // The backend only reads `orderList` and stores it as `list_services`.
    // Sending the same data again under `listServices` doubles the payload.
    delete cleaned.listServices;
    delete cleaned.list_services;

    // Strip heavyweight / UI-only properties from each analysisService item
    // so orders with hundreds of services stay well below nginx's 1 MB limit.
    if (Array.isArray(cleaned.orderList)) {
        cleaned.orderList = cleaned.orderList.map((group) => {
            const { check, view, serviceNames, ...groupRest } = group;
            if (Array.isArray(groupRest.analysisService)) {
                groupRest.analysisService = groupRest.analysisService.map((s) => {
                    const { history, check: _c, view: _v, __v, createdAt, updatedAt, ...sRest } = s;
                    return sRest;
                });
            }
            return groupRest;
        });
    }

    return cleaned;
}


export async function addSample(values) {
    let data = values;
    let headers = {};

    const hasFile = values.fssaiImage && (
        (values.fssaiImage instanceof FileList && values.fssaiImage.length > 0) ||
        values.fssaiImage instanceof File ||
        values.fssaiImage instanceof Blob
    );

    if (hasFile) {
        let file = values.fssaiImage;
        if (values.fssaiImage instanceof FileList) {
            file = values.fssaiImage[0];
        }
        const compressedFile = await compressImageFile(file);

        const formData = new FormData();
        formData.append('fssaiImage', compressedFile);

        const sanitized = sanitizeSamplePayload(values);
        Object.keys(sanitized).forEach((key) => {
            if (key !== 'fssaiImage' && key !== 'fssai_image') {
                if (typeof sanitized[key] === 'object' && sanitized[key] !== null) {
                    formData.append(key, JSON.stringify(sanitized[key]));
                } else {
                    formData.append(key, sanitized[key] !== undefined && sanitized[key] !== null ? sanitized[key] : '');
                }
            }
        });
        data = formData;
        // Do NOT manually set multipart/form-data header so Axios/browser appends correct boundary
        headers = {};
    } else {
        const sanitized = sanitizeSamplePayload(values);
        if (sanitized.fssaiImage && (
            (sanitized.fssaiImage instanceof FileList && sanitized.fssaiImage.length === 0) ||
            (typeof sanitized.fssaiImage === 'object' && Object.keys(sanitized.fssaiImage).length === 0)
        )) {
            delete sanitized.fssaiImage;
        }
        data = sanitized;
        headers = { 'Content-Type': 'application/json' };
    }

    return await axios
        .post(baseUrl + '/sample/create', data, {
            headers: headers,
            maxBodyLength: Infinity,
            maxContentLength: Infinity,
        })
        .then((response) => {
            let sampleResponse = response.data;
            if (sampleResponse.isSucess === true) {
                return sampleResponse.response;
            } else {
                return sampleResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function updateSample(values) {
    let id = values._id;
    let data = values;
    let headers = {};

    const hasFile = values.fssaiImage && (
        (values.fssaiImage instanceof FileList && values.fssaiImage.length > 0) ||
        values.fssaiImage instanceof File ||
        values.fssaiImage instanceof Blob
    );

    if (hasFile) {
        let file = values.fssaiImage;
        if (values.fssaiImage instanceof FileList) {
            file = values.fssaiImage[0];
        }
        const compressedFile = await compressImageFile(file);

        const formData = new FormData();
        formData.append('fssaiImage', compressedFile);

        const sanitized = sanitizeSamplePayload(values);
        Object.keys(sanitized).forEach((key) => {
            if (key !== 'fssaiImage' && key !== 'fssai_image') {
                if (typeof sanitized[key] === 'object' && sanitized[key] !== null) {
                    formData.append(key, JSON.stringify(sanitized[key]));
                } else {
                    formData.append(key, sanitized[key] !== undefined && sanitized[key] !== null ? sanitized[key] : '');
                }
            }
        });
        data = formData;
        // Do NOT manually set multipart/form-data header so Axios/browser appends correct boundary
        headers = {};
    } else {
        const sanitized = sanitizeSamplePayload(values);
        if (sanitized.fssaiImage && (
            (sanitized.fssaiImage instanceof FileList && sanitized.fssaiImage.length === 0) ||
            (typeof sanitized.fssaiImage === 'object' && Object.keys(sanitized.fssaiImage).length === 0)
        )) {
            delete sanitized.fssaiImage;
        }
        data = sanitized;
        headers = { 'Content-Type': 'application/json' };
    }

    return await axios
        .post(baseUrl + '/sample/update/' + id, data, {
            headers: headers,
            maxBodyLength: Infinity,
            maxContentLength: Infinity,
        })
        .then((response) => {
            let sampleResponse = response.data;

            if (sampleResponse.isSucess === true) {
                return sampleResponse.response;
            } else {
                return sampleResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
export async function sendInvoiceMail(formData) {
    try {
        const response = await axios.post(`${baseUrl}/send-invoice-mail`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return true;
    } catch (error) {
        console.error('❌ sendInvoiceMail Error:', error);
        return false;
    }
}
export async function sendBulkAcknowledgementMail(sampleIds) {
    try {
        const response = await axios.post(`${baseUrl}/send-bulk-acknowledgement-mail`, { sampleIds });
        return response.data;
    } catch (error) {
        console.error('❌ sendBulkAcknowledgementMail Error:', error);
        return false;
    }
}
export async function updateSampleStatus(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/sample/Status/update/' + id, values)
        .then((response) => {
            let sampleResponse = response.data;

            if (sampleResponse.isSucess === true) {
                return sampleResponse.response;
            } else {
                return sampleResponse.response;
            }
        })
        .catch((error) => {
            return false;
        });
}

export async function logSampleAction(id, action, userName) {
    return await axios
        .post(baseUrl + '/sample/log-action/' + id, { action, userName })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error logging sample action:', error);
            return { isSucess: false, error };
        });
};

export async function getAllSample(values, config = {}) {
    const signal = values?.signal || config?.signal;
    const reqConfig = signal ? { signal, ...config } : config;
    return await axios
        .post(baseUrl + '/sample/GetSample', values, reqConfig)
        .then((response) => {
            let sampleResponse = response.data;
            if (sampleResponse.isSucess === true) {
                return sampleResponse.response;
            } else {
                return sampleResponse.response;
            }
        })
        .catch((error) => {
            if (axios.isCancel(error) || error?.name === 'CanceledError' || error?.name === 'AbortError') {
                return null;
            }
            console.log(error);
        });
}

export async function exportSampleExcel() {
    try {
        const response = await axios.get(baseUrl + '/sample/exportExcel', {
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'sample_data_export.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return true;
    } catch (error) {
        console.log('Export Excel error:', error);
        throw error;
    }
}

export async function getSampleCounts(values, config = {}) {
    const signal = values?.signal || config?.signal;
    const reqConfig = signal ? { signal, ...config } : config;
    return await axios
        .post(baseUrl + '/sample/GetSampleCounts', values, reqConfig)
        .then((response) => {
            let sampleResponse = response.data;
            if (sampleResponse.isSucess === true) {
                return sampleResponse.response;
            } else {
                return sampleResponse.response;
            }
        })
        .catch((error) => {
            if (axios.isCancel(error) || error?.name === 'CanceledError' || error?.name === 'AbortError') {
                return null;
            }
            console.log(error);
        });
}
export async function getDashboardStatistics(values) {
    return await axios
        .post(baseUrl + '/dashboard/statistics', values)
        .then((response) => {
            let statsResponse = response.data;
            if (statsResponse && (statsResponse.isSuccess === true || statsResponse.isSucess === true)) {
                return statsResponse.response;
            } else {
                return null;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getLabPersonnelWorkload(values, config = {}) {
    const signal = values?.signal || config?.signal;
    const reqConfig = signal ? { signal, ...config } : config;
    return await axios
        .post(baseUrl + '/dashboard/labPersonnelWorkload', values, reqConfig)
        .then((response) => {
            let res = response.data;
            if (res && (res.isSuccess === true || res.isSucess === true)) {
                return res.response || [];
            } else {
                return res?.response || [];
            }
        })
        .catch((error) => {
            if (axios.isCancel(error) || error?.name === 'CanceledError' || error?.name === 'AbortError') {
                return [];
            }
            console.error('Error in getLabPersonnelWorkload API:', error);
            return [];
        });
}

export async function getTopClientsAnalytics(values, config = {}) {
    const signal = values?.signal || config?.signal;
    const reqConfig = signal ? { signal, ...config } : config;
    return await axios
        .post(baseUrl + '/dashboard/topClients', values, reqConfig)
        .then((response) => {
            let res = response.data;
            if (res && (res.isSuccess === true || res.isSucess === true)) {
                return res.response || [];
            } else {
                return res?.response || [];
            }
        })
        .catch((error) => {
            if (axios.isCancel(error) || error?.name === 'CanceledError' || error?.name === 'AbortError') {
                return [];
            }
            console.error('Error in getTopClientsAnalytics API:', error);
            return [];
        });
}
export async function deleteSample(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/sample/delete/' + id)
        .then((response) => {
            let sampleResponse = response.data;
            if (sampleResponse.isSucess === true) {
                return sampleResponse.response;
            } else {
                return sampleResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getSampleHistory(values) {
    return await axios.post(baseUrl + '/sample/history', values).then((response) => {
        let sampleResponse = response.data;
        if (sampleResponse.isSucess === true) {
            return sampleResponse.response;
        } else {
            return sampleResponse.response;
        }
    });
}

export async function getLabDepartmentsByDiscipline(values) {
    return await axios
        .post(baseUrl + '/analysisCategory/departments', values)
        .then((response) => {
            let res = response.data;
            if (res.isSucess === true) {
                return res.response;
            } else {
                return res.response || [];
            }
        })
        .catch((error) => {
            console.log(error);
            return [];
        });
}

export async function getFssaiCategories(values) {
    return await axios
        .post(baseUrl + '/analysisService/fssaiCategories', values)
        .then((response) => {
            let res = response.data;
            if (res.isSucess === true) {
                return res.response;
            } else {
                return res.response || [];
            }
        })
        .catch((error) => {
            console.log(error);
            return [];
        });
}

export async function getAllAnalysisCategory(values) {
    return await axios
        .post(baseUrl + '/analysisCategory/allAnalysisCategory', values)
        .then((response) => {
            let analysisCategoryResponse = response.data;
            if (analysisCategoryResponse.isSucess === true) {
                return analysisCategoryResponse.response;
            } else {
                return analysisCategoryResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAnalysisCategoryHistory(values) {
    return await axios.post(baseUrl + '/analysisCategory/history', values).then((response) => {
        let analysisCategoryResponse = response.data;
        if (analysisCategoryResponse.isSucess === true) {
            return analysisCategoryResponse.response;
        } else {
            return analysisCategoryResponse.response;
        }
    });
}

export async function updateAnalysisCategory(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/analysisCategory/update/' + id, values)
        .then((response) => {
            let analysisCategoryResponse = response.data;
            if (analysisCategoryResponse.isSucess === true) {
                return analysisCategoryResponse.response;
            } else {
                return analysisCategoryResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function deleteAnalysisCategory(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/analysisCategory/delete/' + id)
        .then((response) => {
            let analysisCategoryResponse = response.data;
            if (analysisCategoryResponse.isSucess === true) {
                return analysisCategoryResponse.response;
            } else {
                return analysisCategoryResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAllAnalysisService(values) {
    return await axios
        .post(baseUrl + '/analysisService/allAnalysisService', values)
        .then((response) => {
            let analysisServiceResponse = response.data;
            if (analysisServiceResponse.isSucess === true) {
                return analysisServiceResponse.response;
            } else {
                return analysisServiceResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAnalysisServiceCount(values) {
    return await axios
        .post(baseUrl + '/analysisService/count', values)
        .then((response) => {
            let resData = response.data;
            if (resData && resData.isSucess === true) {
                return resData.response;
            } else {
                return null;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAnalysisServiceHistory(values) {
    return await axios.post(baseUrl + '/analysisService/history', values).then((response) => {
        let analysisServiceResponse = response.data;
        if (analysisServiceResponse.isSucess === true) {
            return analysisServiceResponse.response;
        } else {
            return analysisServiceResponse.response;
        }
    });
}

export async function updateAnalysisService(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/analysisService/update/' + id, values)
        .then((response) => {
            let analysisServiceResponse = response.data;
            if (analysisServiceResponse.isSucess === true) {
                return analysisServiceResponse.response;
            } else {
                return analysisServiceResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function deleteAnalysisService(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/analysisService/delete/' + id)
        .then((response) => {
            let analysisServiceResponse = response.data;
            if (analysisServiceResponse.isSucess === true) {
                return analysisServiceResponse.response;
            } else {
                return analysisServiceResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAllClients(values) {
    return await axios
        .post(baseUrl + '/clients/getClients', values)
        .then((response) => {
            let clientsResponse = response.data;
            if (clientsResponse.isSucess === true) {
                return clientsResponse.response;
            } else {
                return clientsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getClientHistory(values) {
    return await axios.post(baseUrl + '/clients/history', values).then((response) => {
        let clientsResponse = response.data;
        if (clientsResponse.isSucess === true) {
            return clientsResponse.response;
        } else {
            return clientsResponse.response;
        }
    });
}

export async function updateClients(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/clients/update/' + id, values)
        .then((response) => {
            let clientsResponse = response.data;
            if (clientsResponse.isSucess === true) {
                return clientsResponse.response;
            } else {
                return clientsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function deleteClients(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/clients/delete/' + id)
        .then((response) => {
            let clientsResponse = response.data;
            if (clientsResponse.isSucess === true) {
                return clientsResponse.response;
            } else {
                return clientsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
// export async function login(values) {
//   let user = values;
//   return await axios.post(baseUrl + "/login", user).then((response) => {
//     let userResponse = response.data;

//     if (userResponse.isSucess === true) {
//       return userResponse.response;
//     } else {
//       return userResponse.response;
//     }
//   });
// }

export async function getAllUser(values) {
    return await axios.post(baseUrl + '/user/alluser', values).then((response) => {
        let userResponse = response.data;
        if (userResponse.isSucess === true) {
            return userResponse.response;
        } else {
            return userResponse.response;
        }
    });
}

export async function getUserHistory(values) {
    return await axios.post(baseUrl + '/user/history', values).then((response) => {
        let userResponse = response.data;
        if (userResponse.isSucess === true) {
            return userResponse.response;
        } else {
            return userResponse.response;
        }
    });
}

export async function addUser(values) {
    return await axios.post(baseUrl + '/user/signup', values).then((response) => {
        let userResponse = response.data;

        if (userResponse.isSucess === true) {
            return userResponse.response;
        } else {
            return userResponse.response;
        }
    });
}

export async function updateUser(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/user/update/' + id, values).then((response) => {
        let editUserResponse = response.data;
        if (editUserResponse.isSucess === true) {
            return editUserResponse;
        } else {
            return editUserResponse;
        }
    });
}

export async function uploadProfilePic(values) {
    let id = values._id;
    const formData = new FormData();
    formData.append('profilePic', values.profilePic);
    formData.append('userId', values.userId);

    return await axios
        .post(baseUrl + '/user/uploadProfilePic/' + id, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return { isSuccess: false, message: error.message };
        });
}

export async function uploadSignature(values) {
    let id = values._id;
    const formData = new FormData();
    formData.append('signature', values.signature);
    formData.append('userId', values.userId);

    return await axios
        .post(baseUrl + '/user/uploadSignature/' + id, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
            return { isSuccess: false, message: error.message };
        });
}

export async function deleteUser(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/user/delete/' + id, values).then((response) => {
        let deleteUserResponse = response.data;
        if (deleteUserResponse.isSucess === true) {
            return deleteUserResponse;
        } else {
            return deleteUserResponse.isSucess;
        }
    });
}

export async function getAllLabAnalysts() {
    return await axios
        .post(baseUrl + '/user/labanalysts')
        .then((response) => {
            let labAnalystsResponse = response.data;
            if (labAnalystsResponse.isSucess === true) {
                return labAnalystsResponse.response;
            } else {
                return labAnalystsResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getAllLabManagers() {
    return await axios
        .post(baseUrl + '/user/labmanagers')
        .then((response) => {
            let labManagersResponse = response.data;
            if (labManagersResponse.isSucess === true) {
                return labManagersResponse.response;
            } else {
                return labManagersResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addSampleTestResults(values) {
    return await axios
        .post(baseUrl + '/sampleTestResults/create', values)
        .then((response) => {
            let sampleTestResultResponse = response.data;
            if (sampleTestResultResponse.isSucess === true) {
                return sampleTestResultResponse.response;
            } else {
                return sampleTestResultResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function updateSampleTestResults(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/sampleTestResults/update/' + id, values)
        .then((response) => {
            let sampleTestResultResponse = response.data;
            if (sampleTestResultResponse.isSucess === true) {
                return sampleTestResultResponse.response;
            } else {
                return sampleTestResultResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
export async function getAllSampleTestResults(values) {
    return await axios
        .post(baseUrl + '/sampleTestResults/GetSample', values)
        .then((response) => {
            let sampleTestResultResponse = response.data;
            if (sampleTestResultResponse.isSucess === true) {
                return sampleTestResultResponse.response;
            } else {
                return sampleTestResultResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
export async function deleteSampleTestResults(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/sampleTestResults/delete/' + id)
        .then((response) => {
            let sampleTestResultResponse = response.data;
            if (sampleTestResultResponse.isSucess === true) {
                return sampleTestResultResponse.response;
            } else {
                return sampleTestResultResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
// export async function getAllSensor() {
//   return await axios.post(baseUrl + "/allsensor").then((response) => {
//     let sensorResponse = response.data;
//     if (sensorResponse.isSucess === true) {
//       return sensorResponse.response;
//     } else {
//       return sensorResponse.response;
//     }
//   });
// }

export async function analysisGraphAPI(values) {
    return await axios.post(baseUrl + '/graph/analysis', values).then((response) => {
        let graphResponse = response.data;
        if (graphResponse.isSucess === true) {
            return graphResponse.response;
        } else {
            return graphResponse.response;
        }
    });
}

export async function sampleGraphAPI(values) {
    return await axios.post(baseUrl + '/graph/sample', values).then((response) => {
        let graphResponse = response.data;
        if (graphResponse.isSucess === true) {
            return graphResponse.response;
        } else {
            return graphResponse.response;
        }
    });
}

export async function enquiryGraphAPI(values) {
    return await axios.post(baseUrl + '/graph/enquiry', values).then((response) => {
        let graphResponse = response.data;
        if (graphResponse.isSucess === true) {
            return graphResponse.response;
        } else {
            return graphResponse.response;
        }
    });
}

export async function orderGraphAPI(values) {
    return await axios.post(baseUrl + '/graph/order', values).then((response) => {
        let graphResponse = response.data;
        if (graphResponse.isSucess === true) {
            return graphResponse.response;
        } else {
            return graphResponse.response;
        }
    });
}

export async function analysisCardAPI(values) {
    return await axios.post(baseUrl + '/card/analysis', values).then((response) => {
        let cardResponse = response.data;
        if (cardResponse.isSucess === true) {
            return cardResponse.response;
        } else {
            return cardResponse.response;
        }
    });
}

export async function sampleCardAPI(values) {
    return await axios.post(baseUrl + '/card/sample', values).then((response) => {
        let cardResponse = response.data;
        if (cardResponse.isSucess === true) {
            return cardResponse.response;
        } else {
            return cardResponse.response;
        }
    });
}

export async function enquiryCardAPI(values) {
    return await axios.post(baseUrl + '/card/enquiry', values).then((response) => {
        let cardResponse = response.data;
        if (cardResponse.isSucess === true) {
            return cardResponse.response;
        } else {
            return cardResponse.response;
        }
    });
}

export async function orderCardAPI(values) {
    return await axios.post(baseUrl + '/card/order', values).then((response) => {
        let cardResponse = response.data;
        if (cardResponse.isSucess === true) {
            return cardResponse.response;
        } else {
            return cardResponse.response;
        }
    });
}

export async function addFileToUnits(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/units/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToTestMethod(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/testmethods/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToLabDepartments(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/labDepartment/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToAnalysisCategory(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/analysiscategory/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToAnalysisService(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/analysisservice/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToClient(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/clients/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToLabContact(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/labcontact/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToSample(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/sample/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToEnquiry(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/enquiry/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToOrder(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/order/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addFileToUser(values) {
    const formData = new FormData();
    formData.append('file', values);
    return await axios
        .post(baseUrl + '/user/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getSampleOrderId() {
    return await axios
        .post(baseUrl + '/order/sampleorder')
        .then((response) => {
            let orderResponse = response.data;
            if (orderResponse.isSucess === true) {
                return orderResponse.response;
            } else {
                return orderResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getClientInfoAPI(values) {
    const id = values;
    return await axios
        .post(baseUrl + '/clients/clientinfo/' + id)
        .then((response) => {
            let clientsResponse = response.data;
            if (clientsResponse.isSucess === true) {
                return clientsResponse.response;
            } else {
                return clientsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getSelectedOrderListAPI(values) {
    const id = values;
    return await axios
        .post(baseUrl + '/clients/selectedorderinfo/' + id)
        .then((response) => {
            let clientsResponse = response.data;
            if (clientsResponse.isSucess === true) {
                return clientsResponse.response;
            } else {
                return clientsResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addSupplier(values) {
    return await axios.post(baseUrl + '/supplier/create', values).then((response) => {
        let supplierResponse = response.data;

        if (supplierResponse.isSucess === true) {
            return supplierResponse.response;
        } else {
            return supplierResponse.response;
        }
    });
}

export async function updateSupplier(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/supplier/update/' + id, values).then((response) => {
        let editsupplierResponse = response.data;
        if (editsupplierResponse.isSucess === true) {
            return editsupplierResponse;
        } else {
            return editsupplierResponse.isSucess;
        }
    });
}

export async function deleteSupplier(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/supplier/delete/' + id, values).then((response) => {
        let deletesupplierResponse = response.data;
        if (deletesupplierResponse.isSucess === true) {
            return deletesupplierResponse;
        } else {
            return deletesupplierResponse.isSucess;
        }
    });
}

export async function getAllSupplier(values) {
    return await axios.post(baseUrl + '/supplier/allsupplier', values).then((response) => {
        let supplierResponse = response.data;
        if (supplierResponse.isSucess === true) {
            return supplierResponse.response;
        } else {
            return supplierResponse.response;
        }
    });
}

export async function getSupplierHistory(values) {
    return await axios.post(baseUrl + '/supplier/history', values).then((response) => {
        let supplierResponse = response.data;
        if (supplierResponse.isSucess === true) {
            return supplierResponse.response;
        } else {
            return supplierResponse.response;
        }
    });
}

export async function addFileToSupplier(values) {
    const formData = new FormData();
    formData.append('file', values);

    return await axios
        .post(baseUrl + '/supplier/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addSupplierEvaluation(values) {
    return await axios.post(baseUrl + '/supplier/evaluation/create', values).then((response) => {
        let evaluationResponse = response.data;

        if (evaluationResponse.isSucess === true) {
            return evaluationResponse.response;
        } else {
            return evaluationResponse.response;
        }
    });
}

export async function updateSupplierEvaluation(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/supplier/evaluation/update/' + id, values).then((response) => {
        let editEvaluationResponse = response.data;
        if (editEvaluationResponse.isSucess === true) {
            return editEvaluationResponse;
        } else {
            return editEvaluationResponse.isSucess;
        }
    });
}

export async function deleteSupplierEvaluation(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/supplier/evaluation/delete/' + id, values).then((response) => {
        let deleteEvaluationResponse = response.data;
        if (deleteEvaluationResponse.isSucess === true) {
            return deleteEvaluationResponse;
        } else {
            return deleteEvaluationResponse.isSucess;
        }
    });
}

export async function getAllSupplierEvaluation(values) {
    return await axios.post(baseUrl + '/supplier/evaluation/allsupplierevaluation', values).then((response) => {
        let evaluationResponse = response.data;
        if (evaluationResponse.isSucess === true) {
            return evaluationResponse.response;
        } else {
            return evaluationResponse.response;
        }
    });
}

export async function getAllSupplierInfo(values) {
    return await axios.post(baseUrl + '/supplier/all', values).then((response) => {
        let supplierResponse = response.data;
        if (supplierResponse.isSucess === true) {
            return supplierResponse.response;
        } else {
            return supplierResponse.response;
        }
    });
}

export async function getAllEvaluationInfo(values) {
    return await axios.post(baseUrl + '/supplier/evaluation/all', values).then((response) => {
        let evaluationResponse = response.data;
        if (evaluationResponse.isSucess === true) {
            return evaluationResponse.response;
        } else {
            return evaluationResponse.response;
        }
    });
}

export async function getSupplierEvaluationHistory(values) {
    return await axios.post(baseUrl + '/supplier/evaluation/history', values).then((response) => {
        let evaluationResponse = response.data;
        if (evaluationResponse.isSucess === true) {
            return evaluationResponse.response;
        } else {
            return evaluationResponse.response;
        }
    });
}

export async function addFileToSupplierEvaluation(values) {
    const formData = new FormData();
    formData.append('file', values);

    return await axios
        .post(baseUrl + '/supplier/evaluation/file/create', formData)
        .then((res) => {
            let response = res.data;
            if (response.isSucess === true) {
                return response.response;
            } else {
                return response.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addSupplierRating(values) {
    return await axios.post(baseUrl + '/supplier/rating/create', values).then((response) => {
        let ratingResponse = response.data;
        if (ratingResponse.isSucess === true) {
            return ratingResponse.response;
        } else {
            return ratingResponse.response;
        }
    });
}

export async function updateSupplierRating(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/supplier/rating/update/' + id, values).then((response) => {
        let editRatingResponse = response.data;
        if (editRatingResponse.isSucess === true) {
            return editRatingResponse;
        } else {
            return editRatingResponse.isSucess;
        }
    });
}

export async function getAllSupplierRating(values) {
    return await axios.post(baseUrl + '/supplier/rating/allsupplierrating', values).then((response) => {
        let ratingResponse = response.data;
        if (ratingResponse.isSucess === true) {
            return ratingResponse.response;
        } else {
            return ratingResponse.response;
        }
    });
}

export async function getOneSupplierRating(values) {
    return await axios.post(baseUrl + '/supplier/rating/onesupplierrating', values).then((response) => {
        let ratingResponse = response.data;
        if (ratingResponse.isSucess === true) {
            return ratingResponse.response;
        } else {
            return ratingResponse.response;
        }
    });
}

export async function getSupplierRatingHistory(values) {
    return await axios.post(baseUrl + '/supplier/rating/history', values).then((response) => {
        let ratingResponse = response.data;
        if (ratingResponse.isSucess === true) {
            return ratingResponse.response;
        } else {
            return ratingResponse.response;
        }
    });
}

export async function deleteSupplierRating(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/supplier/rating/delete/' + id, values).then((response) => {
        let deleteRatingResponse = response.data;
        if (deleteRatingResponse.isSucess === true) {
            return deleteRatingResponse;
        } else {
            return deleteRatingResponse.isSucess;
        }
    });
}

export async function getAllSupplierRatingList(values) {
    return await axios.post(baseUrl + '/supplier/allsupplieritemlist', values).then((response) => {
        let supplierResponse = response.data;
        if (supplierResponse.isSucess === true) {
            return supplierResponse.response;
        } else {
            return supplierResponse.response;
        }
    });
}

export async function getAllSupplierRatingWithItemList(values) {
    return await axios.post(baseUrl + '/supplier/allsupplierWithitemlist', values).then((response) => {
        let supplierResponse = response.data;
        if (supplierResponse.isSucess === true) {
            return supplierResponse.response;
        } else {
            return supplierResponse.response;
        }
    });
}

export async function postSamplePublishedCountApi() {
    return await axios
        .post(baseUrl + '/sample/samplepublishedcount')
        .then((response) => {
            let sampleCountUpdateResponse = response.data;
            if (sampleCountUpdateResponse && typeof sampleCountUpdateResponse.count !== 'undefined') {
                return sampleCountUpdateResponse;
            } else {
                return sampleCountUpdateResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getSamplePublishedCountApi() {
    return await axios
        .post(baseUrl + '/sample/getsamplepublishedcount')
        .then((response) => {
            let sampleCountResponse = response.data;
            if (sampleCountResponse && typeof sampleCountResponse.count !== 'undefined') {
                return sampleCountResponse;
            } else {
                return sampleCountResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function postSampleUlrCountApi() {
    return await axios
        .post(baseUrl + '/sample/sampleulrcount')
        .then((response) => {
            let sampleCountUpdateResponse = response.data;
            if (sampleCountUpdateResponse && typeof sampleCountUpdateResponse.count !== 'undefined') {
                return sampleCountUpdateResponse;
            } else {
                return sampleCountUpdateResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function postSampleInvoiceCountApi() {
    return await axios
        .post(baseUrl + '/sample/sampleinvoicecount')
        .then((response) => {
            let sampleCountUpdateResponse = response.data;
            if (sampleCountUpdateResponse && typeof sampleCountUpdateResponse.count !== 'undefined') {
                return sampleCountUpdateResponse;
            } else {
                return sampleCountUpdateResponse;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}



export async function updateSampleCount(values) {
    let id = values._id;
    return await axios
        .post(baseUrl + '/sample/samplecountnum/' + id, values)
        .then((response) => {
            let sampleResponse = response.data;

            if (sampleResponse.isSucess === true) {
                return sampleResponse.response;
            } else {
                return sampleResponse.response;
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function addInventory(values) {
    return await axios.post(baseUrl + '/inventory/create', values).then((response) => {
        let inventoryResponse = response.data;

        if (inventoryResponse.isSucess === true) {
            return inventoryResponse.response;
        } else {
            return inventoryResponse.response;
        }
    });
}

export async function updateInventory(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/inventory/update/' + id, values).then((response) => {
        let editInventoryResponse = response.data;
        if (editInventoryResponse.isSucess === true) {
            return editInventoryResponse;
        } else {
            return editInventoryResponse.isSucess;
        }
    });
}

export async function deleteInventory(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/inventory/delete/' + id, values).then((response) => {
        let deleteInventoryResponse = response.data;
        if (deleteInventoryResponse.isSucess === true) {
            return deleteInventoryResponse;
        } else {
            return deleteInventoryResponse.isSucess;
        }
    });
}

export async function getAllInventory(values) {
    return await axios.post(baseUrl + '/inventory/allinventory', values).then((response) => {
        let inventoryResponse = response.data;
        if (inventoryResponse.isSucess === true) {
            return inventoryResponse.response;
        } else {
            return inventoryResponse.response;
        }
    });
}

export async function getAllInventoryList(values) {
    return await axios.post(baseUrl + '/inventory/allinventorylist', values).then((response) => {
        let inventoryResponse = response.data;
        if (inventoryResponse.isSucess === true) {
            return inventoryResponse.response;
        } else {
            return inventoryResponse.response;
        }
    });
}

export async function getInventoryHistory(values) {
    return await axios.post(baseUrl + '/inventory/history', values).then((response) => {
        let inventoryHistoryResponse = response.data;
        if (inventoryHistoryResponse.isSucess === true) {
            return inventoryHistoryResponse.response;
        } else {
            return inventoryHistoryResponse.response;
        }
    });
}

export async function addInventoryUsageLog(values) {
    return await axios.post(baseUrl + '/inventoryUsageLog/create', values).then((response) => {
        let inventoryUsageLogResponse = response.data;
        if (inventoryUsageLogResponse.isSucess === true) {
            return inventoryUsageLogResponse.response;
        } else {
            return inventoryUsageLogResponse;
        }
    });
}

export async function updateInventoryUsageLog(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/inventoryUsageLog/update/' + id, values).then((response) => {
        let inventoryUsageLogResponse = response.data;
        if (inventoryUsageLogResponse.isSucess === true) {
            return inventoryUsageLogResponse.response;
        } else {
            return inventoryUsageLogResponse;
        }
    });
}

export async function deleteInventoryUsageLog(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/inventoryUsageLog/delete/' + id, values).then((response) => {
        let deleteInventoryUsageLogResponse = response.data;
        if (deleteInventoryUsageLogResponse.isSucess === true) {
            return deleteInventoryUsageLogResponse;
        } else {
            return deleteInventoryUsageLogResponse.isSucess;
        }
    });
}

export async function getAllInventoryUsageLog(values) {
    return await axios.post(baseUrl + '/inventoryUsageLog/allinventoryUsageLog', values).then((response) => {
        let inventoryUsageLogResponse = response.data;
        if (inventoryUsageLogResponse.isSucess === true) {
            return inventoryUsageLogResponse.response;
        } else {
            return inventoryUsageLogResponse;
        }
    });
}

export async function getInventoryUsageLogHistory(values) {
    return await axios.post(baseUrl + '/inventoryUsageLog/history', values).then((response) => {
        let inventoryUsageLogHistoryResponse = response.data;
        if (inventoryUsageLogHistoryResponse.isSucess === true) {
            return inventoryUsageLogHistoryResponse.response;
        } else {
            return inventoryUsageLogHistoryResponse.response;
        }
    });
}

export async function addIndent(values) {
    return await axios.post(baseUrl + '/indent/create', values).then((response) => {
        let indentResponse = response.data;

        if (indentResponse.isSucess === true) {
            return indentResponse.response;
        } else {
            return indentResponse.response;
        }
    });
}

export async function updateIndent(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/indent/update/' + id, values).then((response) => {
        let editIndentResponse = response.data;
        if (editIndentResponse.isSucess === true) {
            return editIndentResponse;
        } else {
            return editIndentResponse.isSucess;
        }
    });
}

export async function deleteIndent(values) {
    let id = values._id;
    return await axios.post(baseUrl + '/indent/delete/' + id, values).then((response) => {
        let deleteIndentResponse = response.data;
        if (deleteIndentResponse.isSucess === true) {
            return deleteIndentResponse;
        } else {
            return deleteIndentResponse.isSucess;
        }
    });
}

export async function getAllIndents(values) {
    return await axios.post(baseUrl + '/indent/all', values).then((response) => {
        let indentResponse = response.data;
        if (indentResponse.isSucess === true) {
            return indentResponse.response;
        } else {
            return indentResponse.response;
        }
    });
}

export async function getIndentHistory(values) {
    return await axios.post(baseUrl + '/indent/history', values).then((response) => {
        let indentResponse = response.data;
        if (indentResponse.isSucess === true) {
            return indentResponse.response;
        } else {
            return indentResponse.response;
        }
    });
}

export async function addUnits(values) {
    return await axios.post(baseUrl + '/units/create', values).then((response) => {
        let unitsResponse = response.data;

        if (unitsResponse.isSucess === true) {
            return unitsResponse.response;
        } else {
            return unitsResponse.response;
        }
    });
}

export async function updateUnits(values) {
    try {
        const response = await axios.post(baseUrl + "/units/update", values);
        const result = response.data;

        if (result.isSuccess === true) {
            return {
                success: true,
                data: result.response,
                message: "Unit updated successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Update failed",
            };
        }
    } catch (error) {
        console.error("Error updating unit:", error);
        return {
            success: false,
            message: "Something went wrong while updating the unit.",
        };
    }
}

export async function deleteUnits(values) {
    const id = values?._id || values?.id || values;
    try {
        const response = await axios.post(baseUrl + "/units/delete/" + id, { id });
        const result = response.data;

        if (result.isSuccess === true || result.isSucess === true) {
            return {
                success: true,
                data: result.response,
                message: "Unit deleted successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Failed to delete unit",
            };
        }
    } catch (error) {
        console.error("Error deleting unit:", error);
        return {
            success: false,
            message: "Something went wrong while deleting the unit.",
        };
    }
}

export async function getUnits(values) {
    try {
        const response = await axios.post(baseUrl + "/units/getunits", values);
        const result = response.data;

        if (result.isSuccess === true) {
            return {
                success: true,
                data: result.response,
                message: "Units fetched successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Failed to fetch units",
            };
        }
    } catch (error) {
        console.error("Error fetching units:", error);
        return {
            success: false,
            message: "Something went wrong while fetching units.",
        };
    }
}

export async function getAllUnits(values) {
    try {
        const response = await axios.post(baseUrl + "/units/getallunits", values);
        const result = response.data;

        if (result.isSuccess === true) {
            return {
                success: true,
                data: result.response,
                message: "Units fetched successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Failed to fetch units",
            };
        }
    } catch (error) {
        console.error("Error fetching units:", error);
        return {
            success: false,
            message: "Something went wrong while fetching units.",
        };
    }
}

export async function addTestMethod(values) {
    return await axios.post(baseUrl + '/testmethod/create', values).then((response) => {
        let unitsResponse = response.data;

        if (unitsResponse.isSucess === true) {
            return unitsResponse.response;
        } else {
            return unitsResponse.response;
        }
    });
}

export async function addBillInvoice(values) {
    try {
        const formData = new FormData();
        if (values.file) {
            formData.append("file", values.file);
        }

        formData.append("sampleName", JSON.stringify(values.sampleName));
        formData.append("sampleArray", JSON.stringify(values.sampleArray));
        formData.append("clientId", values.clientId || "");
        formData.append("invoiceNumber", values.invoiceNumber || "");
        formData.append("organizationName", values.organizationName || "");
        formData.append("datePublished", values.datePublished || "");

        const response = await axios.post(baseUrl + "/billinvoice/create", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        let billInvoiceResponse = response.data;
        return billInvoiceResponse.response;

    } catch (error) {
        console.error("Error uploading invoice:", error);
        throw error; // rethrow so caller knows it failed
    }
}

export async function getAllBillInvoice(values) {
    return await axios.post(baseUrl + '/invoice/allBillInvoice', values).then((response) => {
        let billInvoiceResponse = response.data;
        if (billInvoiceResponse.success === true) {
            return billInvoiceResponse;
        } else {
            return billInvoiceResponse;
        }
    });
}



export async function updateTestMethod(values) {
    try {
        const response = await axios.post(baseUrl + "/testmethod/update", values);
        const result = response.data;

        if (result.isSuccess === true) {
            return {
                success: true,
                data: result.response,
                message: "Unit updated successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Update failed",
            };
        }
    } catch (error) {
        console.error("Error updating unit:", error);
        return {
            success: false,
            message: "Something went wrong while updating the unit.",
        };
    }
}

export async function deleteTestMethod(values) {
    const id = values?._id || values?.id || values;
    try {
        const response = await axios.post(baseUrl + "/testmethod/delete/" + id, { id });
        const result = response.data;

        if (result.isSuccess === true || result.isSucess === true) {
            return {
                success: true,
                data: result.response,
                message: "Test method deleted successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Failed to delete test method",
            };
        }
    } catch (error) {
        console.error("Error deleting test method:", error);
        return {
            success: false,
            message: "Something went wrong while deleting the test method.",
        };
    }
}

export async function getTestMethods(values) {
    try {
        const response = await axios.post(baseUrl + "/testmethod/gettestmethods", values);
        const result = response.data;

        if (result.isSuccess === true) {
            return {
                success: true,
                data: result.response,
                message: "Units fetched successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Failed to fetch units",
            };
        }
    } catch (error) {
        console.error("Error fetching units:", error);
        return {
            success: false,
            message: "Something went wrong while fetching units.",
        };
    }
}


export async function getAllTestMethods(values) {
    try {
        const response = await axios.post(baseUrl + "/testmethod/getalltestmethods", values);
        const result = response.data;

        if (result.isSuccess === true) {
            return {
                success: true,
                data: result.response,
                message: "Units fetched successfully",
            };
        } else {
            return {
                success: false,
                message: result.response || "Failed to fetch units",
            };
        }
    } catch (error) {
        console.error("Error fetching units:", error);
        return {
            success: false,
            message: "Something went wrong while fetching units.",
        };
    }
}

export async function updateParameterCasing(originalName, oldName = null) {
    return await axios
        .post(baseUrl + '/parameterCasing/update', { originalName, oldName })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });
}

export async function getParameterCasing() {
    return await axios
        .get(baseUrl + '/parameterCasing/all')
        .then((response) => {
            return response.data?.response || response.data?.data || response.data || {};
        })
        .catch((error) => {
            console.log(error);
            return {};
        });
}

export async function getMyNotifications(payload) {
    return await axios
        .post(baseUrl + '/notification/my-notifications', payload)
        .then((response) => {
            if (response.data && response.data.isSucess) {
                return response.data.response;
            }
            return response.data?.response || response.data || { notifications: [], unreadCount: 0 };
        })
        .catch((error) => {
            console.error('Failed to get notifications:', error);
            return { notifications: [], unreadCount: 0 };
        });
}

export async function markNotificationRead(payload) {
    return await axios
        .post(baseUrl + '/notification/mark-read', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Failed to mark notification as read:', error);
            return null;
        });
}

export async function clearAllNotifications(payload) {
    return await axios
        .post(baseUrl + '/notification/clear-all', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Failed to clear notifications:', error);
            return null;
        });
}

export async function sendDueDateExceededMail(emails) {
    try {
        const response = await axios.post(`${baseUrl}/sample/send-due-date-exceeded-mail`, { emails });
        return response.data;
    } catch (error) {
        console.error('Error sending due date exceeded mail:', error);
        return { success: false, error: error.message };
    }
}